import { useCallback } from 'react'

import type { FPlusDiffLayout } from '../../context/fplusDiffLayout'
import { useLayoutContext } from '../../context/layoutContext'

/**
 * The layout every comparison on the page is read in, kept alongside the
 * reader's other view preferences so it outlasts the page they chose it on.
 */
export const useFPlusDiffLayout = () => {
  const { preferences, onChangeView } = useLayoutContext()

  const onChangeLayout = useCallback(
    (layout: FPlusDiffLayout) =>
      onChangeView({
        ...preferences,
        common: { ...preferences.common, diffLayout: layout },
      }),
    [onChangeView, preferences],
  )

  return { layout: preferences.common.diffLayout, onChangeLayout }
}
